import Swiper, {
  Controller,
} from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Controller]);

export default class SwiperLinked {
  constructor(swiperElements) {
    this.dom = {
      swiperElements,
      root: undefined,
      next: undefined,
      prev: undefined,
    };

    this.data = {
      swiperConfig: {
        loop: true,
        slidesPerView: 1,
        speed: 600,
        // Disable preloading of all images
        // preloadImages: false,
        // Enable lazy loading
        // lazy: {
        //   checkInView: true,
        //   loadPrevNext: true,
        // },
      },
    };

    this.components = {
      swiperInstances: [],
    };

    this.mount();
  }

  mount() {
    // create swiper instances
    this.dom.swiperElements.forEach((swiperElement) => {
      const swiper = new Swiper(swiperElement, this.data.swiperConfig);
      this.components.swiperInstances.push(swiper);
    });

    // update controller params
    this.components.swiperInstances.forEach((instance) => {
      const swiper = instance;
      swiper.controller.control = this.components.swiperInstances.filter((component) => component !== swiper);
    });

    // set root if we have swiper elements
    if (this.dom.swiperElements.length < 1) return;
    this.dom.root = this.dom.swiperElements[0].closest('.widget');

    // set next and prev if we have swiper instances
    if (this.components.swiperInstances.length < 1) return;
    this.dom.next = this.dom.root.querySelector('.swiper-button-next');
    this.dom.prev = this.dom.root.querySelector('.swiper-button-prev');

    // attach slideNext
    if (this.dom.next) {
      this.dom.next.addEventListener('click', () => this.components.swiperInstances[0].slideNext());
    }

    // attach slidePrev
    if (this.dom.prev) {
      this.dom.prev.addEventListener('click', () => this.components.swiperInstances[0].slidePrev());
    }
  }
}
